module.exports = __webpack_public_path__ + "static/media/p3_token.04b0ed2e.png";